import React, { useState } from "react";
import axios from "axios";
import { FiArrowRight, FiCheck, FiCopy } from "react-icons/fi";
import Loader from "./Loader";
import PageHead from "./PageHead";
import { GEMINI_URL } from "../constants";

const SUGGESTIONS = ["Consistent hashing", "Go channels vs mutexes", "Database indexing", "CAP theorem"];

const Ai = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);

  const generateAnswer = async (topic = question) => {
    if (!topic.trim()) return;
    setIsLoading(true);
    setError("");
    try {
      const response = await axios.post(GEMINI_URL, {
        contents: [
          {
            parts: [
              {
                text:
                  "write note about this topic, dont respond to any other query just give notes about this topic in detail, topic is :" +
                  topic,
              },
            ],
          },
        ],
      });
      setAnswer(response.data.candidates[0].content.parts[0].text);
    } catch {
      setError("Couldn't generate notes right now. Try again in a moment.");
    }
    setIsLoading(false);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(answer);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="container tool-page">
      <PageHead
        num="01"
        label="AI Note Generator"
        line1="Any topic,"
        line2="turned into notes."
        lead="Describe what you want to learn. Gemini writes structured technical notes you can copy into your docs."
      />

      <div className="card tool-input reveal">
        <textarea
          className="textarea"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) generateAnswer();
          }}
          placeholder="e.g. How does Raft leader election work?"
        />
        <div className="tool-input__bar">
          <span className="eyebrow">Ctrl + Enter to generate</span>
          <button className="btn btn--accent" onClick={() => generateAnswer()} disabled={isLoading || !question.trim()}>
            Generate notes <FiArrowRight />
          </button>
        </div>
      </div>

      <div className="chips suggestions">
        {SUGGESTIONS.map((s) => (
          <button
            key={s}
            className="chip chip--filter"
            onClick={() => {
              setQuestion(s);
              generateAnswer(s);
            }}
          >
            {s}
          </button>
        ))}
      </div>

      {(isLoading || answer || error) && (
        <section className="card output reveal">
          <div className="output__head">
            <h2 className="eyebrow">Generated notes</h2>
            {answer && !isLoading && (
              <button className="btn btn--sm btn--ghost" onClick={copyToClipboard}>
                {copied ? <FiCheck /> : <FiCopy />} {copied ? "Copied" : "Copy"}
              </button>
            )}
          </div>
          <div className="output__body">
            {isLoading ? <Loader inline label="Writing your notes…" /> : error ? <p className="alert">{error}</p> : answer}
          </div>
        </section>
      )}
    </div>
  );
};

export default Ai;
